
import React from "react";
import "./Terms&Conditions.css";

const sections = [
  {
    id: "about",
    title: "1. About Medhas AI",
    content: {
      paragraph: "Medhas AI is an artificial intelligence platform designed to help individuals, teams, educational institutions, and organizations interact with information through AI-powered conversations, document intelligence, knowledge bases, collaboration tools, and enterprise workspace solutions.Our Services rely on probabilistic machine learning models hosted on our infrastructure. You acknowledge andagree that outputs are algorithmically generated, inherently subject to computational variance, and may evolve over time. Our Services may include:",
      list: [
        "AI-powered conversations",
        "Document and PDF analysis",
        "Image-based AI interactions",
        "Voice-based interactions",
        "Knowledge base creation",
        "Retrieval-Augmented Generation (RAG) workspaces",
        "Collaboration and sharing tools",
        "Partner and enterprise solutions",
        "Subscription-based services",
        "Support and ticketing systems"
      ],
      footer: `As our platform evolves, we may introduce, modify, or discontinue features at our discretion.`
    }
  },
  {
    id: "eligibility",
    title: "2. Eligibility",
    content: {
      paragraph: `You must be at least 18 years old, or the age of legal majority in your jurisdiction, to use Medhas AI independently. 
    If you use Medhas AI on behalf of a company, organization, educational institution, or other entity, you represent that you have authority to bind that entity to these Terms.Furthermore, you represent that you are not located in a country subject to a U.S. Government embargo, or
designated by the U.S. Government as a “terrorist supporting” country, and that you are not listed on any U.S.
Government list of prohibited or restricted parties.`,
    }
  },
  {
    id: "account",
    title: "3. Your Account",
    content: {
      paragraph: "You may register directly or authenticate via supported third-party providers (including Google, Facebook, andLinkedIn etc.). You are solely responsible for maintaining the confidentiality of your account credentials,including any linked third-party authentication tokens, and for all activities that occur under your account. You agree to:",
      list: [
        "Provide accurate, current, and complete registration information.",
        "Keep your credentials secure and unshared.",
        "Notify us immediately at contact@medhas.ai of any unauthorized account access or security breach.",
        "Accept full responsibility for all activities occurring under your account."
      ],
      footer: `We reserve the right to suspend or terminate accounts that violate these Terms, or create operational,
financial, or legal risks to the platform, other users, or our business. If your third-party authentication account
(e.g., Google) is terminated or inaccessible, you acknowledge that you may lose access to your Medhas AI
account, and we assume no liability for such loss.`
    }
  },
  {
    id: "security",
    title: "4. Security and Account Protection",
    content: {
      paragraph: "Medhas AI employs commercially reasonable administrative, technical, and physical security measuresdesigned to protect our platform, which may include network-level protections, verification protocols, rate-limiting, and security monitoring.",
      footer: "Repeated unauthorized access attempts, system abuse, scraping, or suspicious activity targeting ourinfrastructure may result in immediate account restrictions, temporary suspension, or permanent termination,and we reserve the right to report malicious activities to law enforcement or relevant infrastructure partners."
    }
  },
  {
    id: "content",
    title: "5. Content You Provide",
    content: {
      paragraph: "You retain all ownership rights to the uploaded documents, text, images, audio, and other inputs you submit to the platform (“User Content”). By uploading or submitting User Content to Medhas AI, you grant us aworldwide, non-exclusive, royalty-free, fully paid-up license to store, process, analyze, index, and retrieve your content to deliver the Services to you and your authorized collaborators.",

      // list:[
      //   "Store your content",
      //   "Process your content",
      //   "Analyze your content",
      //   "Index your content",
      //   "Retrieve information from your content",
      //   "Deliver requested Services",
      //   "you will receive automated informational and scheduling text messages from Medhas AI at the phone number,email provided ."
      // ],

      footer: `Furthermore, you agree that Medhas AI, LLC may utilize anonymized or de-identified User Content, prompt
inputs, and system interactions to retrain, optimize, and improve our underlying artificial intelligence models,
refine machine learning outputs, and enhance the overall user experience. If you wish to opt out of having your
User Content utilized for future model refinement, you may request an opt-out at any time by submitting a
written request to contact@medhas.ai, and we will process your request manually in accordance with
applicable data privacy regulations.`
    }
  },
  {
    id: "ai",
    title: "6. AI Generated Content",
    content: {
      paragraph: "You acknowledge that the outputs generated by Medhas AI are produced by automated algorithms. AI outputsmay contain inaccuracies, incomplete details, or misleading information(“hallucinations”).Outputs do not constitute, and should not be relied upon as, professional, legal, medical, financial, tax, ortechnical advice.You assume all risk and liability arising from your reliance on, publication of, or distribution ofAI- generated outputs.Medhas AI does not warrant that outputs are unique, and you acknowledge that different users may receive identical or similar outputs."
    } 
  },
{
  id: "rag",
    title: "7. Knowledge Bases and RAG Workspaces",
      content: {
    paragraph: "Medhas AI enables organizations and partners to create private knowledge bases and Retrieval-AugmentedGeneration (RAG) workspaces using uploaded documents and proprietary data. Access to these workspacesis regulated through Access Keys, invitations, user permissions, and organization controls.Users are strictly prohibited from:",
      list: [
       "Accessing or attempting to access workspaces without express authorization",
"Circumventing workspace permission barriers or security controls.",
"Sharing restricted access credentials or keys with unauthorized personnel",
"Executing reverse-engineering prompts or extraction strategies designed to pull information beyondtheir authorized tier."
      ],
        footer: `Violation of these requirements will result in immediate account termination and potential legal exposure.`
  }
},
{
  id: "collab",
    title: "8. Collaboration Features",
      content: {
    paragraph: "Our Services allow users to collaborate through shared conversations, joint workspaces, and collaborativeknowledge environments. Workspace administrators and owners are solely responsible for:",
      list: [
        "Managing user permissions and roles.",
        "Monitoring, validating, and controlling system invitations.",
        "Removing unauthorized users promptly.",
        "Complying with applicable employment and data privacy laws regarding internal user monitoring."
      ],
        footer: `Medhas AI acts solely as a technical processor and is not liable for data exposure resulting from information
voluntarily shared among collaborators.`
  }
},
{
  id: "subs",
    title: "9. Subscription Services",
      content: {
    paragraph: "Certain premium tiers, features, and expanded token capabilities of Medhas AI require paid subscriptions(“Individual”, “Professional”,“Partner”, or “Enterprise”;). The specific features, token volume, limits, and pricing are explicitly detailed at the time of purchase."
    ,
      
        footer: `We reserve the right to modify pricing, subscription tiers, or plan architectures. Any pricing adjustments willapply to your subsequent billing cycle following at least thirty (30) days&#39; prior notice sent to your registeredemail address. This 30-day period means that if we announce a price increase, the new price will not takeeffect on your account for at least 30 days, giving you a full 30-day window to evaluate the changes and cancelyour subscription before your account is automatically charged at the new rate."`
  }
},
{
  id: "billing",
    title: "10. Billing and Payments",
      content: {
    paragraph: `Paid subscriptions operate on a continuous service basis and renew automatically at the conclusion of each
billing cycle unless canceled before the next renewal date. You authorize Medhas AI and our designated third-
party payment processors to charge your selected payment method for all applicable fees.
In compliance with applicable continuous service and consumer protection regulations, you may cancel your
subscription easily and exclusively online at any time through your account dashboard. Failure to complete
scheduled payments will result in:`,
      list: [
        "Immediate loss of premium access.",
        "Downgrading to the standard free tier (if available).",
        "Suspension of organizational workspaces and shared access keys."
      ]
  }
},
{
  id: "refunds",
    title: "11. Refunds",
      content: {
    paragraph: `All subscription payments, transaction fees, and advanced token purchases are strictly non-refundable, except
as required by applicable federal or state law, or as otherwise explicitly determined in writing by Medhas AI,
LLC.`
  }
},
{
  id: "aup",
    title: "12. Acceptable Use Policy",
      content: {
    paragraph: "You agree to use Medhas AI exclusively for lawful purposes. You shall not use, nor permit any third party touse, the Services to:",
      list: [
        "Violate federal, state, local, or international laws, including United States export control laws. “Export control laws; mean U.S. federal regulations (such as the Export Administration Regulations) that restrictthe transfer, sharing, or deployment of advanced technical software, encrypted assets, and high-performance artificial intelligence models to specific foreign nationals, blacklisted corporate entities, orU.S.-embargoed nations (e.g., Iran, North Korea, Russia, Syria).",
        "Execute “jailbreaks”,; prompt injections, or adversarial inputs designed to bypass system safety filters oralter model behavioral bounds.",
        "Use outputs generated by Medhas AI to train, fine-tune, or validate competing artificial intelligencesoftware, large language models, or machine learning frameworks.",
        "Reverse-engineer, decompile, or extract the underlying model weights, embeddings, or system promptsof Medhas AI.",
        "Deploy automated scrapers, bots, crawlers, or data extraction tools without express written authorization.",
        "Copy, clone, mirror, scrape, or duplicate the website structure, database schemas, services, userinterfaces, layouts, color schemes, or visual elements to create a competing website, application, or software platform.",
      ],
        footer: `We reserve the right to investigate and take action against violations.`
  }
},
{
  id: "ip",
    title: "13. Intellectual Property",
      content: {
    paragraph: "The Medhas AI platform, proprietary interfaces, source code, software, documentation, system prompts, fine-tuning configurations, customized model weights, logos, branding, and visual designs are the exclusiveintellectual property of Medhas AI, LLC, and are protected under United States and international copyright,trademark, patent, and trade dress laws. These Terms grant you a limited, non-assignable, revocable licenseto access the interface; they do not transfer any ownership rights in our technology or intellectual property to you.",
      footer: "You are strictly prohibited from copying, adapting, modifying, or reproducing our website, userinterface, or proprietary services to launch a derivative or competing platform. If any unauthorizedduplication, corporate espionage, or intellectual property infringement is discovered, Medhas AI, LLC will immediately pursue legal action. We reserve the right to sue for maximum statutory and compensatory damages, seek immediate emergency injunctive relief to shut down offending platforms,and recover all associated legal fees and court costs to the maximum extent permitted by law."
  }
},
{
  id: "third",
    title: "14. Third-Party Services",
      content: {
    paragraph: "Medhas AI relies upon, hosts infrastructure with, and integrates with sophisticated third-party service providers,including but not limited to third-party cloud hosting infrastructure networks, web security and caching applications, email and SMS communication routing platforms, and secure third-party payment gates and authentication systems.",
      list: [
        "Cloudflare",
        "Twilio",
        "SendGrid",
        "Payment Processors",
        "Authentication Providers",
        "AI Model Providers",
        "Cloud Infrastructure Providers"
      ],
        footer: `Your use of Medhas AI is simultaneously bound by the acceptable use policies and service terms of these
underlying third-party ecosystems. Medhas AI, LLC acts independently and assumes no operational or legal
liability for service disruptions, technical downtime, security breaches, or unexpected modifications initiated by
these external third-party infrastructure providers.`
  }
},
{
  id: "availability",
    title: "15. Service Availability",
      content: {
    paragraph: "We work to provide reliable Services but cannot guarantee uninterrupted availability.Services may occasionally be unavailable due to:",
      list: [
        "Maintenance, upgrades, security incidents, third-party failures, infrastructure outages.",
        "We are not responsible for losses resulting from temporary interruptions."
      ],
        footer: "We are not responsible for losses resulting from temporary interruptions."
  }
},
{
  id: "liability",
    title: "16. Limitation of Liability",
      content: {
    paragraph: `To the maximum extent permitted by applicable law, including the laws of the State of New Jersey, Medhas AI,
LLC, its affiliates, officers, directors, employees, and infrastructure partners shall not be liable for any indirect,
incidental, special, consequential, punitive, or exemplary damages, including but not limited to loss of profits,
loss of data, loss of goodwill, business interruption, or procurement of substitute services, arising out of or in
connection with your use of the Services.`,
        footer: `In no event shall the total aggregate liability of Medhas AI, LLC for all claims arising under these Terms exceed
the greater of one hundred U.S. dollars ($100.00) or the actual amount paid by you to Medhas AI, LLC for the
specific service tier triggering the dispute during the twelve (12) months immediately preceding the event.`
  }
},
{
  id: "indemnification",
    title: "17. Indemnification",
      content: {
    paragraph: "You agree to defend, indemnify, and hold harmless Medhas AI, LLC, its members, managers, officers,employees, contractors, and infrastructure providers from and against any third-party claims, liabilities,damages, judgments, losses, costs, expenses, or fees (including reasonable attorneys&#39; fees) arising out of or relating to:",
      list: [
        "Your violation of these Terms",
        "The explicit nature, copyright ownership, or legality of any User Content you upload to our RAG workspaces.",
        "Your deployment, publication, or commercial reliance on AI-generated outputs that cause harm,defamation, or financial loss to a third party."
      ]
  }
},
{
  id: "termination",
    title: "18. Suspension and Termination",
      content: {
    paragraph: "We reserve the right to suspend, restrict, or terminate your account access immediately and without prior notice if we determine, in our sole discretion, that:",
      list: [
        "You have breached any provision of these Terms or the Acceptable Use Policy.",
        "Your data usage patterns present an acute security threat to our third-party networks, hosting environments, or infrastructure partners.",
        "Continued operation of your account exposes the Company to legal or regulatory liability.",
      ],
        footer: `Upon termination, your right to use the platform ceases immediately, and we reserve the right to delete
accumulated conversational history and knowledge bases.`
  }
},
{
  id: "changes",
    title: "19. Changes to the Services",
      content: {
    paragraph: `We continuously iterate and update the capabilities of Medhas AI. We reserve the absolute right to add new
modules, modify RAG architectures, restrict technical parameters, alter token rates, or remove features entirely
without liability. We are under no legal obligation to support or maintain any specific technical legacy feature
indefinitely.`
  }
},
{
  id: "terms",
    title: "20. Changes to These Terms",
      content: {
    paragraph: "We may update these Terms from time to time. When material modifications occur, we will provide notice by updating the “Last Updated” date at the top of this document and displaying a prominent notification banner within the platform application or via an email dispatch to your registered account. Your continued use of Medhas AI following the deployment of updated Terms constitutes your explicit and binding acceptance of the revisions."
  }

},
{
  id: "law",
    title: "21. Governing Law and Venue",
      content: {
    paragraph: `These Terms, your access to the Services, and any legal relationship between you and Medhas AI, LLC shall
be governed by, construed, and enforced in accordance with the laws of the State of New Jersey, United
States, without giving effect to any principles of conflicts of law.
Subject to the mandatory arbitration provisions outlined in Section 23, any permitted judicial proceedings
arising out of this agreement must be initiated exclusively in the state or federal courts located in the State of
New Jersey.`
  }
},
{
  id: "TCPA Compliance",
    title: "22. Communications and SMS Opt-In (TCPA Compliance)",
      content: {
    paragraph: `By registering an account, providing your email address, or voluntarily choosing to submit your telephone
number to the website (which is an optional field), you grant express, affirmative consent to Medhas AI, LLC to
transmit transactional, administrative, security verification (such as multi-factor authentication codes),
informational updates, and promotional marketing communications to you. We may utilize automated electronic
mail networks and automated text-messaging communication platforms (such as third-party application-to-
person messaging services) to connect with existing or potential customers.`,
list: [
  "Standard message and data rates applied by your mobile carrier may apply to any received text messages.",
  "Mobile carriers are not liable for delayed or undelivered messages.",
  "Message frequency varies based on your platform interactions and workspace settings.",

  "You acknowledge that consenting to marketing and promotional communications is entirely voluntary and is not a mandatory condition for purchasing our core software or accessing the platform.",

  "You may obtain assistance at any time by texting &#39;HELP&#39; to our number or emailing contact@medhas.ai. You may opt out of SMS text communications at any absolute time by replying 'STOP'  to any text message received. You may opt out of promotional email communications at any time by clicking the 'Unsubscribe' link in the footer of our emails or by sending us an email at contact@medhas.ai with the subject 'Unsubscribe&#39'."
]
  }
},{
  id: "Dispute Resolution",
    title: "23. Dispute Resolution: Binding Arbitration &amp; Class Action Waiver",
      content: {
    paragraph: `Please read this section carefully, as it affects your legal rights.`,
    list: [
      "Mandatory Arbitration: You and Medhas AI, LLC agree that any dispute, claim, or controversy arising out of or relating to these Terms, the breach thereof, or the use of the Services shall be settled by final,binding individual arbitration administered by the American Arbitration Association (AAA) under its Commercial Arbitration Rules. Judgment on the award rendered by the arbitrator may be entered in any court having jurisdiction. The place of arbitration shall be New Jersey, and the proceedings shall be conducted in English.",
      "Class Action Waiver: You and Medhas AI, LLC explicitly agree that any dispute resolutionproceedings will be conducted solely on an individual basis and not in a class, consolidated, or representative action. You explicitly waive your right to participate as a plaintiff or class member in any purported class action lawsuit or class-wide arbitration."
    ]
  }
},
{
  id: "Copyright",
    title: "24.Digital Millennium Copyright Act (DMCA) Policy",
      content: {
    paragraph: `Medhas AI respect the intellectual property rights of others and requires our users to do the same. If you
believe that any content hosted within our platform or public user workspaces infringes upon a copyright you
own or control, you may submit a formal notification to our Designated Copyright Agent containing:`,
list: [
  "A physical or electronic signature of a person authorized to act on behalf of the owner of the copyright.",
  "Direct identification of the copyrighted work claimed to have been infringed.",
  "Precise identification of the material on our platform that must be removed or disabled.",
  "Your contact information, including address, telephone number, and email.",
  "A statement that you have a good faith belief that use of the material is unauthorized.",
  "A statement made under penalty of perjury that the information provided is accurate."
],
footer:"All DMCA notifications must be routed directly to: contact@medhas.ai (Attn: DMCA Agent)."
  }
},
{
  id: "contact",
    title: "25. Contact Us",
      content: {
    paragraph: `For any legal inquiries, administrative notifications, or technical support requests regarding these Terms,
please contact us at:`,
list: [
  "Medhas AI, LLC Email: contact@medhas.ai; https://medhas.ai",
  "Mailing Address: 2230 Route 70W, STE 2, Cherry Hill, NJ-08002"
]

  }
}
];

const TermsConditions = () => {
  return (
    <div className="terms-layout">
      <aside className="terms-sidebar">
        <div className="brand">Medhas AI</div>
        <h3>Terms of Service</h3>
        {sections.map((s) => (
          <a key={s.id} href={`#${s.id}`}>{s.title}</a>
        ))}
      </aside>

      <main className="terms-main">
        <section className="hero">
          <span className="badge">Legal Document</span>
          <h1>Terms of Service</h1>
          <p>
            Welcome to Medhas AI. These Terms of Service (&quot;Terms&quot;) constitute a legally binding agreement between you
            (&quot;User,&quot; &quot;you,&quot; or &quot;your&quot;) and Medhas AI, LLC (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;), a New Jersey limited liability
            company. By accessing or using our website, applications, and artificial intelligence platform (collectively, the
            &quot;Services&quot;), you agree to be bound by these Terms. If you do not agree to these Terms, do not use the
            Services.
          </p>
          <div className="hero-meta">
            <span>Effective Date: June 2026</span>
            <span>Version 1.0</span>
          </div>
        </section>

        {sections.map((s) => (
          <section id={s.id} key={s.id} className="term-card">
            <h2>{s.title}</h2>
            <p>{s?.content?.paragraph}</p>
            {s?.content?.list && (
              <ul className="legal-list">
                {s.content.list.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}
            {s?.content?.footer && (
              <p className="footer-text">{s.content.footer}</p>
            )}
          </section>
        ))}

        <div className="footer-card">
          <h3>Legal Notice</h3>
          <p>
            By using Medhas AI, you acknowledge that you have read, understood,
            and agreed to these Terms of Service.
          </p>
        </div>
      </main>
    </div>
  );
}

export default TermsConditions;